import React, { Component, Fragment } from 'react'
import Radium from 'radium'
import { NavLink } from 'react-router-dom'

import images from '../../../config/images'

import $ from 'jquery'

class Navbar extends Component {
  componentDidMount() {
    // Sandwich menu
    $('.mobile button').click(function() {
      $(this)
        .toggleClass('expanded')
        .siblings('div')
        .slideToggle()
      $('#header').toggleClass('nav-expanded')
    })

    //Highlight Active Page
    $('nav ul li a.nav-link').each(function() {
      if ($(this).attr('href') === window.location.pathname) {
        $(this).addClass('highlighted')
      }
    })
  }
  render() {
    return (
      <Fragment>
        <nav className="navbar">
          <div className="brand-container">
            <img src={images.logo} alt="RPFPC Logo" className="logo" />
          </div>
          <div className="container">
            <ul>
              <li>
                <NavLink className="nav-link" activeClassName="highlighted" exact to="/">
                  HOME
                </NavLink>
              </li>
              <li>
                <NavLink className="nav-link" activeClassName="highlighted" exact to="/about">
                  ABOUT
                </NavLink>
              </li>
              <li>
                <NavLink className="nav-link" activeClassName="highlighted" exact to="/programs">
                  PROGRAMS
                </NavLink>
              </li>
              <li>
                <NavLink className="nav-link" activeClassName="highlighted" exact to="/events">
                  EVENTS
                </NavLink>
              </li>
              <li>
                <NavLink className="nav-link" activeClassName="highlighted" exact to="/press">
                  PRESS
                </NavLink>
              </li>
            </ul>
          </div>
          <div className="social">
            <a
              href="https://www.facebook.com/rpfpchicago"
              target="_blank"
              rel="noopener noreferrer"
              className="social-link"
            >
              <img src={images.social.facebook} alt="facebook" title="Facebook" />
            </a>
            <a
              href="https://www.twitter.com/retirednflchi"
              target="_blank"
              rel="noopener noreferrer"
              className="social-link"
            >
              <img src={images.social.twitter} alt="twitter" title="Twitter" />
            </a>
          </div>
        </nav>
        <nav className="mobile">
          <div className="brand-container">
            <img src={images.logo} alt="RPFPC Logo" className="logo" />
          </div>
          <button>
            <img src={images.menu_button} alt="menu button" />
          </button>
          <div className="container">
            <ul>
              <li>
                <NavLink className="nav-link" activeClassName="highlighted" exact to="/">
                  HOME
                </NavLink>
              </li>
              <li>
                <NavLink className="nav-link" activeClassName="highlighted" exact to="/about">
                  ABOUT
                </NavLink>
              </li>
              <li>
                <NavLink className="nav-link" activeClassName="highlighted" exact to="/programs">
                  PROGRAMS
                </NavLink>
              </li>
              <li>
                <NavLink className="nav-link" activeClassName="highlighted" exact to="/events">
                  EVENTS
                </NavLink>
              </li>
              <li>
                <NavLink className="nav-link" activeClassName="highlighted" exact to="/press">
                  PRESS
                </NavLink>
              </li>
            </ul>
          </div>
        </nav>
      </Fragment>
    )
  }
}

Navbar.propTypes = {}

Navbar.defaultProps = {}

export default Radium(Navbar)
